//안드로이드에서는 버튼을 무시하고 바로 다운로드 됨
import React, { useEffect } from 'react';

const DownloadLink = () => {
  const rawUrl = new URLSearchParams(window.location.search).get('s3Url');
  const presignedUrl = rawUrl ? decodeURIComponent(rawUrl) : '';


  const handleDownload = () => {
    if (!presignedUrl) {
      alert('다운로드 링크가 없습니다.');
      return;
    }

    const link = document.createElement('a');
    link.href = presignedUrl;
    link.setAttribute('download', '');
    // link.setAttribute('target', '_blank');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    // 자동 다운로드 실행 (원하면 주석 해제)
    // handleDownload();
  }, []);

  return (
    <div style={{ padding: '10rem', textAlign: 'center' }}>
      <button
        onClick={handleDownload}
        style={{
          backgroundColor: '#007BFF',
          color: '#fff',
          fontSize: '16px',
          padding: '0.75rem 1.5rem',
          border: 'none',
          borderRadius: '8px',
          cursor: 'pointer'
        }}
      >
        다운로드
      </button>

      {/* <div style={{ marginTop: '2rem', color: '#555' }}>
        URL: <br />
        <code style={{ wordBreak: 'break-all' }}>{presignedUrl || '없음'}</code>
      </div> */}
    </div>
  );
};

export default DownloadLink;
